import React from 'react';
import useTargetStorage from "@/hooks/useTargetStorage"
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Section from 'components/layout/section';
import SectionHeader from 'components/layout/sectionHeader';
import SectionHeaderTitle from 'components/layout/sectionHeaderTitle';
import SectionHeaderActions from 'components/layout/sectionHeaderActions';
import Button from 'components/inputs/button';
import { ReactComponent as AddIcon } from 'assets/icons/add.svg';
import PageTitle from 'features/navigation/pageTitle';
import useAccess from '@/hooks/useAccess';
import { AccessRole, DeviceSize, FormStatus } from 'types';
import TransactionList from 'components/transactions/TransactionList';
import useTransactions from '@/hooks/useTransactions';
import useStorages from '@/hooks/useStorages';
import { paramGuardStorage } from '@/utils/paramGuard';
import FloatingButtonGroup from '@/components/buttons/floatingButtonGroup';
import FloatingButtonGroupButton from '@/components/buttons/FloatingButtonGroupButton';
import { ReactComponent as ArrowDropDownIcon } from 'assets/icons/arrow_drop_down.svg';
import IconButton from '@/components/buttons/iconButton';
import useWindowDimensions from '@/hooks/useWindowDimensions';
import RightSidebar from '@/components/sidebar/right/RightSidebar';
import { MainSheetHeaderActions } from '@/components/layout/layoutChrome';

const TransactionsPage: React.FC = () => {
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { targetStorageDocId: storageId } = useTargetStorage();
  const { deviceSize } = useWindowDimensions();

  const {
    limitToRoles
  } = useAccess({ storageId: storageId || '' });

  const {
    transactionsStatus
  } = useTransactions({ storageId });

  const { 
    storage,
    storageStatus,
    isTransactionsEnabled
  } = useStorages({ storageId });

  // Check params and declare safe ones to use in JSX
  if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
    return <></>
  }
  const safeStorageId = storageId!;

  // Redirect if transactions are disabled for this storage
  if (!isTransactionsEnabled()) {
    navigate(`/storage`);
    return <></>;
  }

  const openingButton = deviceSize === DeviceSize.SM ?
    <IconButton colorScheme='blue' icon={<AddIcon />} /> :
    <Button wideOnMobile design="primary"><AddIcon />{t('buttonNewTransaction')}<ArrowDropDownIcon /></Button>

  return (
    <>
      <PageTitle title={`${t('titleTransactions')}`} />
      <MainSheetHeaderActions>
        {limitToRoles([AccessRole.OWNER, AccessRole.EDITOR, AccessRole.WORKER]) && 
          <>
            <FloatingButtonGroup id={`transaction-list-helper-transactions-page`} openingButton={openingButton}>
                <FloatingButtonGroupButton to={`/storages/${storageId}/transactions/create/incoming`}>{t('buttonNewIncoming')}</FloatingButtonGroupButton>
                <FloatingButtonGroupButton to={`/storages/${storageId}/transactions/create/outgoing`}>{t('buttonNewOutgoing')}</FloatingButtonGroupButton>
            </FloatingButtonGroup>
          </>
        }
      </MainSheetHeaderActions>
      <Section padX={false}>
        <TransactionList storageId={safeStorageId} />

      </Section>
      <RightSidebar storageId={safeStorageId} />
    </>
  );
};

export default TransactionsPage;
